import moment from 'moment';
import { connect } from 'react-redux';
import React from 'react';
import './RemedialTrainingTable.scss';

const RemedialTrainingTable = (props) => {
  // ----------------------
  // Methods
  // ----------------------

  function getCanCompleteRemedial(status) {
    return props.userContext.hasScope(['fto', 'ftoc', 'sup'])
      && status === 'reviewed';
  }

  // ----------------------
  // Render
  // ----------------------

  return (
    <div className="remedial-training-table">
      <h4 className="header">Additional Training</h4>
      <table className="table table-stripped table-small">
        <thead>
          <tr>
            <th>
              Date Assigned
            </th>
            <th>
              Status
            </th>
            <th>
              Actions
            </th>
          </tr>
        </thead>
        <tbody>
          {props.remedials && props.remedials.map((remedial, index) => {
            return (
              <tr key={index.toString()}>
                <td>{moment(remedial.assignedAt).format('MMM D, YYYY')}</td>
                <td style={{textTransform: 'capitalize'}}>{remedial.status}</td>
                <td>
                  {getCanCompleteRemedial(remedial.status) &&
                    <button
                      className="button small delete"
                      onClick={() => props.onComplete({ completedAt: moment(), remedialGuid: remedial.guid })}
                    >
                      <i className="fa fa-power-off" />
                      <span>Complete</span>
                    </button>
                  }
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    userContext: state.common.userContext,
  };
};

export default connect(mapStateToProps, null)(RemedialTrainingTable);
